export enum ResponseActionsPermissions {
  readAllResponses = 'allresponses.read',
  deleteAllResponses = 'allresponses.delete',
  createResponses = 'responses.create',
  readResponses = 'responses.read',
  deleteResponses = 'responses.delete',
  createMyResponse = 'myresponse.create',
}
